<template>
  <banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @click="routeToBilling"
  />
</template>

<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';
import accountMixin from 'dashboard/mixins/account';

export default {
  components: { Banner },
  mixins: [adminMixin, accountMixin],
  computed: {
    ...mapGetters({
      subscription: 'accounts/getSubscriptionInfo',
    }),
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.LIMITS_UPGRADE');
    },
    actionButtonMessage() {
      return this.$t('GENERAL_SETTINGS.OPEN_BILLING');
    },
    shouldShowBanner() {
      if (!this.isAdmin) {
        return false;
      }
      if (!this.subscription.plan_name) {
        return false;
      }
      return this.isLimitExceeded();
    },
  },
  methods: {
    routeToBilling() {
      this.$router.push({
        name: 'billing_settings_index',
        params: { accountId: this.accountId },
      });
    },
    isLimitExceeded() {
      const usage = this.subscription.usage || {};
      const plan = this.subscription.plan || {};

      const conversationsExceeded =
        plan.max_conversations &&
        usage.conversations_used >= plan.max_conversations;

      const agentsExceeded =
        plan.max_agents && usage.agents_count >= plan.max_agents;

      return Boolean(conversationsExceeded || agentsExceeded);
    },
  },
};
</script>
